import CancelablePromise from "../cancelable-promise";

class VariantUpdate {
    constructor() {
        this._init()
    }
    _init() {
        this.el = document.querySelector('[data-variants]')
        if (!this.el) {
            return;
        }

        this.fetchUrl = this.el.dataset.variants
        this.elVariants = this.el.querySelectorAll('[data-variants-selection]')

        this.elVariants.forEach((el, i) => {
            el.variant = new Variant(el, i, this)
            if (i != 0) {
                el.variant.setActions(false)
            }
        })

        this.elInput = document.querySelectorAll('[data-variants-input]')
        this.elStock = this.el.querySelector('[data-variants-stock]')
        this.elSubmit = this.el.querySelector('[data-variants-submit]')
        this.elExtras = this.elSubmit.querySelectorAll('[data-variants-extra]')

        this.elSubmit.addEventListener('click', e => {
            if (this.allowPopup) {
                e.preventDefault()
                this.setSearch()
            }
        })

        this.elLoading = this.el.querySelector('[data-loading]')
        this.elPrice = document.querySelector('[data-variants-price]')
        this.elBasePrice = document.querySelector('[data-variants-base-price]')
        this.allowPopup = false
        this.onVariantClick(-1);
        this.currAlt = null

        this.setPriceUpdateWhenOptionsChange()
    }

    setPriceUpdateWhenOptionsChange() {
        document.querySelectorAll('[data-options]').forEach((el) => {
            el.addEventListener('change', () => {
                this.updatePriceWithOptions()
            }, true)
        })
    }

    updatePriceWithOptions() {
        const priceOptions = [0, ...[...document.querySelectorAll('[data-increment-price]')]
            .map((el) => {
                const optionEl = el.querySelector('input[data-option-yes]')
                if (!optionEl || optionEl.checked === false) {
                    return 0.0
                }
                return Number.parseFloat(el.dataset.incrementPrice)
            })].reduce((acc, currValue) => {
                return acc + currValue
            })

        const priceEl = document.querySelector('[data-variants-price]')
        if (priceEl) {
            const price = Number.parseFloat(!priceEl ? 0 : priceEl.dataset.variantsPrice)
            priceEl.innerText = this.getFormatted(price + priceOptions)
        }

        const priceBaseEl = document.querySelector('[data-variants-base-price]')
        if (priceBaseEl) {
            const price = Number.parseFloat(!priceBaseEl ? 0 : priceBaseEl.dataset.variantsBasePrice)
            priceBaseEl.innerText = this.getFormatted(price + priceOptions)
        }
    }

    //#region SearchParams
    setSearch() {
        const params = new URLSearchParams(window.location.search)
        params.set('popup', 'notify')
        this.updateURL(params)
        this.dispatchEvent()
    }
    updateURL(params) {
        params.sort()
        window.history.pushState({}, '', `${location.pathname}?${params}`)
    }
    dispatchEvent() {
        const popStateEvent = new PopStateEvent('popstate', { state: null })
        window.dispatchEvent(popStateEvent)
    }
    //#endregion

    switchSubmit(on, message = true) {
        this.elSubmit.classList.add('selafano-button--alternative-text1')
        if (on) {
            this.elSubmit.disabled = false
            this.elSubmit.classList.add('selafano-button-is-active')
            if (message) {
                this.elSubmit.classList.remove('selafano-button--alternative-text2')
            }
        } else {
            this.elSubmit.disabled = true
            this.elSubmit.classList.remove('selafano-button-is-active')
            if (message) {
                this.elSubmit.classList.add('selafano-button--alternative-text2')
            }
        }
    }

    enableSubmit(on) {
        if (on) {
            this.elSubmit.disabled = false
            this.elSubmit.classList.add('selafano-button-is-active')
        } else {
            this.elSubmit.disabled = true
            this.elSubmit.classList.remove('selafano-button-is-active')
        }
    }

    setMessage(m) {
        // null  - "Select an Option"
        // '1'   - "Add to cart"
        // '2'   - "Out-of-Stock"
        // '3'   - "Stock Limit Reached"
        this.setAltStockMessage(false)

        if (!m) {
            // this.elSubmit.classList.remove('selafano-button--alternative-text1')
            this.elSubmit.classList.remove('selafano-button--alternative-text' + this.currAlt)
            return
        }

        this.elSubmit.classList.remove('selafano-button--alternative-text' + this.currAlt)
        this.currAlt = m;
        this.elSubmit.classList.add('selafano-button--alternative-text' + this.currAlt)
    }

    switchStock(on) {
        if (on) {
            this.elStock.classList.add('product-page__warning-is-out-of-stock')
        } else {
            this.elStock.classList.remove('product-page__warning-is-out-of-stock')
        }
    }

    setAltStockMessage(on) {
        if (on) {
            this.elStock.classList.add('product-page__warning--limit')
        } else {
            this.elStock.classList.remove('product-page__warning--limit')
        }
    }

    switchLoading(on) {
        if (on) {
            this.elLoading.classList.add('lds-spinner--active')
        } else {
            this.elLoading.classList.remove('lds-spinner--active')
        }
    }

    setExtras(newExtra) {
        this.elExtras.forEach(el => {
            el.innerText = newExtra
        })
    }

    processProduct(data) {
        if (!data) {
            // this.switchSubmit(false)
            this.enableSubmit(false)
            this.allowPopup = true
            this.setMessage(2)
            this.switchStock(false)
            return
        }

        if (data['extra'] && this.elExtras.length) {
            this.setExtras(data['extra'])
        }

        if (data['quantity'] > data['currQuantity']) {
            // this.switchSubmit(true)
            this.enableSubmit(true)
            this.setMessage(1)
            this.switchStock(false)
            return
        }

        if (data['allow_purchase_out_of_stock']) {
            // this.switchSubmit(true)
            this.enableSubmit(true)
            this.setMessage(1)
            if (data['quantity'] == data['currQuantity']) {
                this.setAltStockMessage(true)
            }
            this.switchStock(true)
            return
        }

        // this.switchSubmit(false)
        if (data['quantity'] == 0) {
            this.enableSubmit(!data['isNotified'])
            this.allowPopup = true
            this.setMessage(2)
        }
        else if (data['quantity'] == data['currQuantity']) {
            this.enableSubmit(false)
            this.setMessage(3)
            this.setAltStockMessage(true)
        }
        else {
            this.enableSubmit(false)
            this.setMessage(3)
        }

        this.switchStock(false)
        this.updatePriceWithOptions();
    }

    processVariant(data, index) {
        if (!data) {
            // this.switchSubmit(false)
            this.enableSubmit(false)
            this.setMessage(2)
            this.switchStock(false);

            [].forEach.call(this.elInput, function (elI) {
                elI.value = 'null'
            })
            this.updatePriceWithOptions()
            return
        }

        if (data['extra'] && this.elExtras.length) {
            this.setExtras(data['extra'])
        }

        if (index != this.elVariants.length - 1) {
            let nextId = this.elVariants[index + 1].variant.id
            this.elVariants[index + 1].variant.setActionsFrom(data['attributes'][nextId])
            this.setMessage(null)
            this.enableSubmit(false)
            this.switchStock(false)
            this.updatePriceWithOptions()
            return
        }

        if (this.elPrice) {
            this.elPrice.innerText = data['price'] || data['price'] === 0 ? this.getFormatted(data['price']) : this.elPrice.innerText
            this.elPrice.dataset.variantsPrice = data['price'] || data['price'] === 0 ? data['price'] : this.elPrice.innerText
        }

        if (this.elBasePrice) {
            this.elBasePrice.innerText = data['basePrice'] || data['basePrice'] === 0 ? this.getFormatted(data['basePrice']) : this.elBasePrice.innerText
            this.elBasePrice.dataset.variantsPrice = data['basePrice'] || data['basePrice'] === 0 ? data['basePrice'] : this.elBasePrice.innerText
        }

        [].forEach.call(this.elInput, function (elI) {
            elI.value = data['variant-id'] ? data['variant-id'] : -1
        })

        if (data['quantity'] > data['currQuantity']) {
            this.enableSubmit(true)
            this.setMessage(1)
            this.switchStock(false)
            this.updatePriceWithOptions()
            return
        }

        if (data['allow_purchase_out_of_stock']) {
            this.enableSubmit(true)
            this.setMessage(1)
            if (data['quantity'] == data['currQuantity']) {
                this.setAltStockMessage(true)
            }
            this.switchStock(true)
            this.updatePriceWithOptions()
            return
        }

        if (typeof (data['quantity']) != 'undefined' && data['quantity'] == 0) {
            this.enableSubmit(!data['isNotified'])
            this.allowPopup = true
            this.setMessage(2)
        }
        else if (data['quantity'] == data['currQuantity']) {
            this.enableSubmit(false)
            this.setMessage(3)
            this.setAltStockMessage(true);
            [].forEach.call(this.elInput, function (elI) {
                elI.value = 'null'
            });
        }
        else {
            this.enableSubmit(false)
            this.setMessage(2);
            [].forEach.call(this.elInput, function (elI) {
                elI.value = 'null'
            });
        }
        this.switchStock(false)
        this.updatePriceWithOptions()
    }

    fetchData(selection = null) {
        let json = JSON.stringify({
            'selection': selection,
        })

        return fetch(this.fetchUrl,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: json,
            })
            .then(response => response.json())
    }

    onVariantClick(index) {
        this.enableSubmit(false)
        this.switchStock(false)
        this.switchLoading(true)
        this.allowPopup = false

        let prevSelected = null
        if (this.elVariants.length != 0) {
            this.resetVariantSelectedAfter(index)
            prevSelected = this.getSelections(index)
        }
        if (this.promise) {
            this.promise.cancel()
            this.promise = null
        }

        this.promise = new CancelablePromise(this.fetchData(prevSelected))

        this.promise.run()
            .then(data => {
                if (data['isProduct']) {
                    this.processProduct(data)
                }
                else {
                    this.processVariant(data, index)
                }
            })
            .catch(error => {
                this.processProduct(false)
            })
            .finally(() => {
                this.switchLoading(false)
            })
    }
    resetVariantSelectedAfter(index) {
        for (let i = index + 1; i < this.elVariants.length; i++) {
            this.elVariants[i].variant.deselect()
            //turn off variants after the picked one
            this.elVariants[i].variant.setActions(false)
        }
    }
    getSelections(index) {
        let prevSel = {}

        for (let i = index; i >= 0; i--) {
            prevSel[this.elVariants[i].variant.id] = this.elVariants[i].variant.getSelectedId()
        }

        return prevSel
    }
    getFormatted(value) {
        let s = parseFloat(value).toFixed(2)
        s = s.split('.')
        let formatted = s[0] + "," + s[1]
        return formatted
    }
}

class Variant {
    constructor(el, index, manager) {
        this._init(el, index, manager)
    }
    _init(el, index, manager) {
        this.el = el
        this.index = index
        this.manager = manager

        this.id = this.el.dataset.variantsSelection
        this.selected = null
        this.elActions = this.el.querySelectorAll('[data-variants-action]')
        this.elActions.forEach((elAction, index) => {
            elAction.index = index
            elAction.variantId = parseInt(elAction.dataset.id)
            elAction.addEventListener('change', () => {
                if (elAction.checked) {
                    this.selected = elAction.index
                    this.manager.onVariantClick(this.index)
                }
            })
        })
    }

    deselect() {
        if (this.selected) {
            this.elActions[this.selected].checked = false
        }
        this.selected = null
    }
    getSelectedId() {
        return this.selected != null ? this.elActions[this.selected].variantId : null
    }
    setActions(on) {
        this.elActions.forEach(el => {
            el.disabled = !on
            el.checked = false
        })
    }
    setActionsFrom(array) {
        this.elActions.forEach(el => {
            if (typeof (array[el.variantId]) == 'undefined') {
                el.disabled = true
                el.classList.add('disabled')
            }
            else {
                el.disabled = false

                if (array[el.variantId]) {
                    el.classList.remove('disabled')
                }
                else {
                    el.classList.add('disabled')
                }
            }
        })
    }
}

export default VariantUpdate